// Module
var code = "<div class=\"select-users\" ng-click=\"$ctrl.openSelectorModal()\" data-test-id=\"send-for-approval-modal-select-reviewers-dropdown\">+ {{ \"add_people\" | localize }}</div>";
// Exports
module.exports = code;